import React from "react";
import PropTypes from "prop-types";
import "../../css/View/TripVariantsSection.css";

const TripVariantsSection = ({ variants, onVariantClick }) => {
  if (!variants || variants.length === 0) {
    return <p>Brak dodanych wariantów.</p>;
  }

  const formatDate = (dateString) => {
    if (!dateString) return "?";
    const date = new Date(dateString);
    return date.toLocaleDateString("pl-PL", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  return (
    <div className="trip-variants">
      <div className="variants-list">
        {variants.map((variant) => {
          return (
            <div
              key={variant.guid}
              className="variant-item"
              onClick={() => onVariantClick(variant.guid)}
            >
              <div className="variant-icon-container">
                <i className="fas fa-route" title="Wariant wycieczki"></i>
              </div>
              <div className="variant-details">
                <h3>{variant.name}</h3>
                <div className="variant-dates">
                {formatDate(variant.startDate)} – {formatDate(variant.endDate)}
              </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

TripVariantsSection.propTypes = {
  variants: PropTypes.arrayOf(
    PropTypes.shape({
      guid: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      startDate: PropTypes.string,
      endDate: PropTypes.string,
    })
  ).isRequired,
  onVariantClick: PropTypes.func.isRequired,
};

export default TripVariantsSection;
